module.exports = "<div class=\"flex\">\n    <div class=\"block\">\n        <h1>Liste des clients possédant un {{bike.brand}} - {{bike.model}}</h1>\n        <h2 *ngIf=\"customerList.length==0\">Aucune personne trouvée</h2>\n        <div class=\"customers\">\n            <div *ngFor=\"let d of customerList; let i = index;\" class=\"customer\" (click)=\"openCustomer(d._id)\" [class.archive]=\"d.archive\">\n                <span class=\"firstname\">{{d.lastName}}</span><br>\n                {{d.firstName}}\n            </div>\n        </div>\n    </div>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/home/pages/bike/bike.component.html
// module id = 744
// module chunks = 1